import { useEffect } from 'react';
import useHttpGetProjectFiles from '../../../hooks/project/projectApi/useHttpGetProjectFiles';
import ProjectFilesTable from '../ProjectFilesTable';
import ProjectFileUpload from '../ProjectFileUpload';

export default function ProjectFilesTab({ projectId }: { projectId: string }) {
    const { projectFiles, areProjectFilesReady, exec: fetchProjectFiles } = useHttpGetProjectFiles(projectId);
    const tableHeadCellData = [{ label: 'File' }, { label: 'Name' }, { label: 'Date' }, { label: 'Time' }, { label: 'Action' }];
    useEffect(() => {
        fetchProjectFiles();
    }, [projectId]);

    return (
        <div className="project-files-container">
            <div className="project-files-container__table">
                <ProjectFilesTable tableHeadCellData={tableHeadCellData} tableData={projectFiles} isDataReady={areProjectFilesReady} />
            </div>
            <div>
                <ProjectFileUpload projectId={projectId} onUploadSuccess={fetchProjectFiles} />
            </div>
        </div>
    );
}
